import Stepper from 'components/Stepper';
import PropTypes from 'prop-types';
import React from 'react';
import * as styles from './styles.module.scss';

export default function ReferralLayout({ activeStep, paragraphText, heroAvif, heroWebp, heroJpg, heroAlt, heading, iconAlt, iconSrc, children }) {
  return (
    <>
      <div className={styles.hero}>
        <picture className={styles.picture}>
          <source srcSet={heroAvif} type="image/avif" />
          <source srcSet={heroWebp} type="image/webp" />
          <img alt={heroAlt} src={heroJpg} className={styles.img} />
        </picture>
        <div className={styles.iconContainer}>
          <img alt={iconAlt} className={styles.icon} src={iconSrc} />
        </div>
      </div>
      <div className={styles.content}>
        {/* these might be better in a grid with a gap of margin bottom */}
        <Stepper classes={styles.stepper} activeStep={activeStep} steps={2} />
        <h1 className={styles.heading}>{heading}</h1>
        <p className={styles.introduction}>{paragraphText}</p>
        <div className={styles.secondary}>{children}</div>
      </div>
    </>
  );
}

ReferralLayout.propTypes = {
  activeStep: PropTypes.oneOf([0, 1]).isRequired,
  children: PropTypes.node.isRequired,
  heading: PropTypes.node.isRequired,
  heroAlt: PropTypes.string.isRequired,
  heroAvif: PropTypes.string.isRequired,
  heroJpg: PropTypes.string.isRequired,
  heroWebp: PropTypes.string.isRequired,
  iconAlt: PropTypes.string.isRequired,
  iconSrc: PropTypes.string.isRequired
};
